import { DataModel } from "../../base/index.js";
import type { DnsRecordSrvData, DnsRecordSrvEntry } from "./types.js";
import {
  DnsRecordSettings,
  type DnsRecordSettingsData,
} from "../DnsRecordSettings/index.js";
import type { DnsZoneCommon } from "../DnsZone/index.js";
import { DnsZone } from "../DnsZone/index.js";

export class DnsRecordSrv extends DataModel<DnsRecordSrvData> {
  public dnsZone: DnsZoneCommon;
  public records?: DnsRecordSrvEntry[];
  public settings?: DnsRecordSettings;

  public constructor(dnsZone: DnsZoneCommon, data: DnsRecordSrvData) {
    super(data);
    this.dnsZone = dnsZone;
    if ("records" in data) {
      this.records = data.records;
      this.settings = new DnsRecordSettings(data.settings);
    }
  }

  public getTtl(): number | "auto" {
    if (this.settings) {
      return this.settings.ttl;
    }
    return "auto";
  }

  public async updateEntry(
    entry: DnsRecordSrvEntry,
    newEntry: DnsRecordSrvEntry,
    settings: DnsRecordSettingsData,
  ) {
    const existingItems = this.dnsZone.recordSet.srv.records ?? [];
    if (existingItems.length < 1) {
      return;
    }
    const update = existingItems.map((i) => (i === entry ? newEntry : i));
    await this.dnsZone.setSrvRecord(update, settings);
  }
  public async addEntry(
    newEntry: DnsRecordSrvEntry,
    settings: DnsRecordSettingsData,
  ) {
    const existingItems = this.dnsZone.recordSet.srv.records ?? [];
    await this.dnsZone.setSrvRecord([newEntry, ...existingItems], settings);
  }

  public async addRecord(
    service: string,
    protocol: string,
    newEntry: DnsRecordSrvEntry,
    settings: DnsRecordSettingsData,
  ) {
    const newZone = await DnsZone.create(
      `${service}.${protocol}`,
      this.dnsZone.id,
    );
    const newZoneDetailed = await newZone.getDetailed();
    await newZoneDetailed.recordSet.srv.addEntry(newEntry, settings);
  }

  public async removeEntry(entry: DnsRecordSrvEntry) {
    const existingItems = this.dnsZone.recordSet.srv.records ?? [];
    if (
      existingItems.length <= 1 ||
      this.dnsZone.recordSet.srv.settings === undefined
    ) {
      return;
    }
    const update = existingItems.filter((i) => i !== entry);
    await this.dnsZone.setSrvRecord(
      update,
      this.dnsZone.recordSet.srv.settings.data,
    );
  }
}
